import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, getFormValues, change } from 'redux-form';
import { Link } from 'react-router-dom';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas } from '../../../../../helpers';
import { updatePaginationSkip } from '../../../../../../reducers/calculator';
import { formDetails as StepOneFormDetails } from '../step-one';
import { formDetails as StepTwoFormDetails } from '../step-two';
import { formDetails as StepThreeFormDetails } from '../step-three';
import { formDetails as StepFourFormDetails } from '../step-four';
import { formDetails as StepFiveFormDetails } from '../step-five';
import { formDetails as StepSixFormDetails } from '../step-six';

export const formDetails = {
    key: 'summary',
    title: 'Summary',
    formName: Routes.SUMMARY,
    summaryFieldsKey: 'summaryFields'
};

const incomeButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPONE}`,
    label: 'Edit'
};

const housingButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPTWO}`,
    label: 'Edit'
};

const transportationButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPTHREE}`,
    label: 'Edit'
};

const debtButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPFOUR}`,
    label: 'Edit'
};

const livingButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPFIVE}`,
    label: 'Edit'
};

const savingsButton = {
    link: `${process.env.PUBLIC_URL}/budget-planner${Routes.STEPSIX}`,
    label: 'Edit'
};

class SummaryForm extends Component {
    componentDidMount() {
        const {
            props: {
                changeFieldValue,
                summaryFields
            }
        } = this;

        changeFieldValue(formDetails.summaryFieldsKey, summaryFields);
    }

    render() {
        const {
            props: {
                summaryFields,
                updatePaginationSkip
            }
        } = this;

        return (
            <form className={styles.form}>
                {
                    summaryFields.map(field => (
                        <div key={field.key} className={styles.formSection}>
                            <div className={styles.sectionDivider}>
                                <ul className={styles.summaryList}>
                                    <li className={styles.label}>
                                        <span className={styles.summaryTitle}>{field.title} Total:</span>
                                        <strong className={styles.summaryValue}>${numberWithCommas(field.total)}</strong>
                                    </li>
                                    {
                                        Object.keys(field.values).map(key => (
                                            <li key={key}>
                                                <span className={styles.summaryTitle}>{field.fields[key].label}:</span>
                                                <strong className={styles.summaryValue}>${numberWithCommas(field.values[key])}</strong>
                                            </li>
                                        ))
                                    }
                                </ul>
                                <Link
                                    to={field.button.link}
                                    onClick={() => updatePaginationSkip(true)}
                                    className={styles.button}
                                    title={field.button.label}
                                >
                                    {field.button.label}
                                </Link>
                            </div>
                        </div>
                    ))
                }
            </form>
        );
    }
}

SummaryForm = reduxForm({
    form: formDetails.formName,
    destroyOnUnmount: false
})(SummaryForm);

const StepOneForm = formValueSelector(StepOneFormDetails.formName);
const StepOneFormValues = getFormValues(StepOneFormDetails.formName);
const StepTwoForm = formValueSelector(StepTwoFormDetails.formName);
const StepTwoFormValues = getFormValues(StepTwoFormDetails.formName);
const StepThreeForm = formValueSelector(StepThreeFormDetails.formName);
const StepThreeFormValues = getFormValues(StepThreeFormDetails.formName);
const StepFourForm = formValueSelector(StepFourFormDetails.formName);
const StepFourFormValues = getFormValues(StepFourFormDetails.formName);
const StepFiveForm = formValueSelector(StepFiveFormDetails.formName);
const StepFiveFormValues = getFormValues(StepFiveFormDetails.formName);
const StepSixForm = formValueSelector(StepSixFormDetails.formName);
const StepSixFormValues = getFormValues(StepSixFormDetails.formName);

const mapStateToProps = (state) => {
    if(!StepOneForm(state, StepOneFormDetails.totalKey)){
        return {
            summaryFields: []
        };
    }

    const incomeTotal = StepOneForm(state, StepOneFormDetails.totalKey);
    const {
        [StepOneFormDetails.totalKey]: removedIncomeTotal,
        ...incomeValues
    } = StepOneFormValues(state);
    const housingTotal = StepTwoForm(state, StepTwoFormDetails.totalKey);
    const {
        [StepTwoFormDetails.totalKey]: removedHousingTotal,
        ...housingValues
    } = StepTwoFormValues(state);
    const transportationTotal = StepThreeForm(state, StepThreeFormDetails.totalKey);
    const {
        [StepThreeFormDetails.totalKey]: removedTransportationTotal,
        ...transportationValues
    } = StepThreeFormValues(state);
    const debtTotal = StepFourForm(state, StepFourFormDetails.totalKey);
    const {
        [StepFourFormDetails.totalKey]: removedDebtTotal,
        ...debtValues
    } = StepFourFormValues(state);
    const livingTotal = StepFiveForm(state, StepFiveFormDetails.totalKey);
    const {
        [StepFiveFormDetails.totalKey]: removedLivingTotal,
        ...livingValues
    } = StepFiveFormValues(state);
    const savingsTotal = StepSixForm(state, StepSixFormDetails.totalKey);
    const {
        [StepSixFormDetails.totalKey]: removedSavingsTotal,
        ...savingsValues
    } = StepSixFormValues(state);

    const summaryFields = [
        {
            ...StepOneFormDetails,
            total: incomeTotal,
            values: incomeValues,
            button: incomeButton
        },
        {
            ...StepTwoFormDetails,
            total: housingTotal,
            values: housingValues,
            button: housingButton
        },
        {
            ...StepThreeFormDetails,
            total: transportationTotal,
            values: transportationValues,
            button: transportationButton
        },
        {
            ...StepFourFormDetails,
            total: debtTotal,
            values: debtValues,
            button: debtButton
        },
        {
            ...StepFiveFormDetails,
            total: livingTotal,
            values: livingValues,
            button: livingButton
        },
        {
            ...StepSixFormDetails,
            total: savingsTotal,
            values: savingsValues,
            button: savingsButton
        }
    ];

    return {
        summaryFields
    }
};

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value)),
    updatePaginationSkip: dispatch(updatePaginationSkip)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SummaryForm);
